export const APIs = {
    authLogin: `api/authentication/login`,
    forgotPassword: `api/authentication/forgot-password`,
    confirmForgotPasswordReset: `api/authentication/confirm-forgot-password`,
    acceptInvitation: `api/invitation/accept-invitation`,
    acceptAdminInvitation: `api/invitation/accept-admin-invitation`,
    verifyInvitation: `api/invitation/verify-invitation`,
    sendAuthCode: `api/invitation/send-auth-code`,
    refreshJwtToken: `api/authentication/refresh-token`,
    onlineCheck: `api/authentication/online-check`,
    verifyCellPhoneNumber: 'api/authentication/verify-cellphone-number',
    verifySignupCellPhoneNumber: 'api/authentication/verify-signup-cellphone-number',
    verifyPasswordToken: 'api/authentication/verify-password-token',
    submitUserHelpForm: 'api/authentication/submit-user-help-form',
    tenantCurrent: 'api/tenancy/current',
    checkUsernamePhoneNumber: 'api/authentication/check-username-phone-number',
    addOAPractitioner: 'api/authentication/add-oa-practitioner',
    updateOAPractitioner: 'api/authentication/update-oa-practitioner',
    registerPractitioner: 'api/authentication/register-wl-user',
    updateUsernamePassword: 'api/invitation/update-username-password',
    sendOAWLAuthCode: 'api/invitation/send-oa-wl-auth-code',
    verifyOAWLAuthCode: 'api/invitation/verify-oa-wl-auth-code',
    verifyOAWLAuthCodeStatus: 'api/invitation/verify-oa-wl-auth-code-status',
    getLatestAuthCode: 'api/invitation/get-latest-auth-code',
    verifyOAPrincipalInvitation: 'api/invitation/verify-oa-principal-invitation',
    verifyPrincipalToken: 'api/invitation/verify-principal-token',
    addTenantSetupInfo: 'api/setup/add-tenant-setup-info',
    validateNewTenant: 'api/setup/validate-new-tenant',
    fetchAllLanguages: 'api/setup/fetch-available-languages',
    getConsentForPortal: 'api/setup/get-consent-for-portal',
    sendNewInvitation: 'api/invitation/send-new-invitation',
};
//# sourceMappingURL=end-points.js.map